import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { buildIntranetPathname, getLocaleFromPathname } from 'utils/localePath';

const useIntranetPath = () => {
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);

  return useCallback(
    (suffix = '', targetLocale = locale) => buildIntranetPathname(suffix, targetLocale),
    [locale],
  );
};

export default useIntranetPath;
